/**
 * @generated SignedSource<<dc61024d0d0db16937e4a4e1ca582b8d>>
 * @relayHash 830e3a87656c190d259f4de3cffb876c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8f025b5712462290c910466d41e500bb7d42f2334e5cca14610d8725a9d29be5

import type { ConcreteRequest } from 'relay-runtime';
export type appConnectors_twg_microsite_SearchCombinedConfig_Query$variables = {
  cloudId: string;
};
export type appConnectors_twg_microsite_SearchCombinedConfig_Query$data = {
  readonly search: {
    readonly configuration: {
      readonly firstPartyProducts: ReadonlyArray<{
        readonly name: string;
      }>;
      readonly intercomHmac: string | null;
      readonly siteMetadata: {
        readonly applicationMode: string | null;
        readonly isJiraIssueIndexed: boolean;
        readonly isRovoEnabled: boolean;
        readonly orgId: string;
        readonly productEdition: string | null;
        readonly productInfo: ReadonlyArray<{
          readonly dataRegion: ReadonlyArray<string>;
          readonly name: string;
        }>;
        readonly siteName: string;
      };
      readonly thirdPartyProducts: ReadonlyArray<{
        readonly connectionId: string | null;
        readonly connectorCreatedAt: string | null;
        readonly connectorSyncType: string | null;
        readonly datasourceId: string | null;
        readonly entityTypes: ReadonlyArray<string> | null;
        readonly environmentType: string | null;
        readonly integrationARI: string;
        readonly isImpersonationAuthEnabled: boolean | null;
        readonly isUserOAuthed: boolean;
        readonly lightIcon: string | null;
        readonly name: string;
        readonly outboundAuthUrl: string;
        readonly providerId: string | null;
        readonly workspaceName: string | null;
        readonly workspaceUrl: string | null;
      }>;
    } | null;
  } | null;
};
export type appConnectors_twg_microsite_SearchCombinedConfig_Query = {
  response: appConnectors_twg_microsite_SearchCombinedConfig_Query$data;
  variables: appConnectors_twg_microsite_SearchCombinedConfig_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "name"
},
v2 = [
  {
    "concreteType": "SearchQueryAPI",
    "kind": "LinkedField",
    "name": "search",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "SearchGraphQLConfigurationResponse",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
          {
            "concreteType": "SearchFirstPartyMetadata",
            "kind": "LinkedField",
            "name": "firstPartyProducts",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ]
          },
          {
            "concreteType": "SearchThirdPartyMetadata",
            "kind": "LinkedField",
            "name": "thirdPartyProducts",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "outboundAuthUrl"
              },
              {
                "kind": "ScalarField",
                "name": "isUserOAuthed"
              },
              {
                "kind": "ScalarField",
                "name": "providerId"
              },
              {
                "kind": "ScalarField",
                "name": "integrationARI"
              },
              {
                "kind": "ScalarField",
                "name": "workspaceName"
              },
              {
                "kind": "ScalarField",
                "name": "workspaceUrl"
              },
              {
                "kind": "ScalarField",
                "name": "datasourceId"
              },
              {
                "kind": "ScalarField",
                "name": "connectionId"
              },
              {
                "kind": "ScalarField",
                "name": "connectorSyncType"
              },
              {
                "kind": "ScalarField",
                "name": "isImpersonationAuthEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "connectorCreatedAt"
              },
              {
                "kind": "ScalarField",
                "name": "lightIcon"
              },
              {
                "kind": "ScalarField",
                "name": "entityTypes"
              },
              {
                "kind": "ScalarField",
                "name": "environmentType"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "intercomHmac"
          },
          {
            "concreteType": "SearchConfigurationSiteMetadata",
            "kind": "LinkedField",
            "name": "siteMetadata",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isRovoEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isJiraIssueIndexed"
              },
              {
                "kind": "ScalarField",
                "name": "applicationMode"
              },
              {
                "kind": "ScalarField",
                "name": "siteName"
              },
              {
                "kind": "ScalarField",
                "name": "orgId"
              },
              {
                "kind": "ScalarField",
                "name": "productEdition"
              },
              {
                "concreteType": "SearchProductInfo",
                "kind": "LinkedField",
                "name": "productInfo",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "dataRegion"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "appConnectors_twg_microsite_SearchCombinedConfig_Query",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "appConnectors_twg_microsite_SearchCombinedConfig_Query",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "8f025b5712462290c910466d41e500bb7d42f2334e5cca14610d8725a9d29be5",
    "metadata": {},
    "name": "appConnectors_twg_microsite_SearchCombinedConfig_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "30926d71734e98454a9fd61a37953b2f";

export default node;
